import { unreachable } from 'utils/unreachable';
import { FieldType } from '../fields';
import { AssigneeFieldFilter } from './assignee';
import { BooleanFieldFilter } from './boolean';
import { DateFieldFilter } from './date';
import { EstimateFieldFilter } from './estimate';
import { MultiSelectFieldFilter } from './multi-select';
import { MultiUserFieldFilter } from './multi-user';
import { NumberFieldFilter } from './number';
import { TermSeparator } from './separators';
import { SingleSelectFieldFilter } from './single-select';
import { SingleUserFieldFilter } from './single-user';
import { TextFieldFilter } from './text';
const isValid = (filter)=>{
    if (!(filter === null || filter === void 0 ? void 0 : filter.field)) {
        return false;
    }
    switch(filter.field.type){
        case FieldType.Boolean:
            return BooleanFieldFilter.isValid(filter);
        case FieldType.Number:
            return NumberFieldFilter.isValid(filter);
        case FieldType.Date:
            return DateFieldFilter.isValid(filter);
        case FieldType.Text:
        case FieldType.MultiLineText:
        case FieldType.Note:
            return TextFieldFilter.isValid(filter);
        case FieldType.SingleSelect:
            return SingleSelectFieldFilter.isValid(filter);
        case FieldType.MultiSelect:
            return MultiSelectFieldFilter.isValid(filter);
        case FieldType.Assignee:
            return AssigneeFieldFilter.isValid(filter);
        case FieldType.SingleUser:
            return SingleUserFieldFilter.isValid(filter);
        case FieldType.MultiUser:
            return MultiUserFieldFilter.isValid(filter);
        case FieldType.Estimate:
            return EstimateFieldFilter.isValid(filter);
        default:
            return unreachable(filter.field);
    }
};
const toCriteriaString = (filter)=>{
    var _filter_field;
    switch((_filter_field = filter.field) === null || _filter_field === void 0 ? void 0 : _filter_field.type){
        case FieldType.Boolean:
            return BooleanFieldFilter.toString(filter);
        case FieldType.Number:
            return NumberFieldFilter.toString(filter);
        case FieldType.Date:
            return DateFieldFilter.toString(filter);
        case FieldType.Text:
        case FieldType.MultiLineText:
        case FieldType.Note:
            return TextFieldFilter.toString(filter);
        case FieldType.SingleSelect:
            return SingleSelectFieldFilter.toString(filter);
        case FieldType.MultiSelect:
            return MultiSelectFieldFilter.toString(filter);
        case FieldType.Assignee:
            return AssigneeFieldFilter.toString(filter);
        case FieldType.SingleUser:
            return SingleUserFieldFilter.toString(filter);
        case FieldType.MultiUser:
            return MultiUserFieldFilter.toString(filter);
        case FieldType.Estimate:
            return EstimateFieldFilter.toString(filter);
        default:
            return unreachable(filter.field);
    }
};
const toString = (filter)=>{
    if (!(filter === null || filter === void 0 ? void 0 : filter.field)) {
        return '';
    }
    return [
        filter.field.fieldName,
        toCriteriaString(filter)
    ].join(TermSeparator);
};
const parse = (field, filter)=>{
    switch(field.type){
        case FieldType.Boolean:
            return BooleanFieldFilter.parse(filter, field);
        case FieldType.Number:
            return NumberFieldFilter.parse(filter, field);
        case FieldType.Date:
            return DateFieldFilter.parse(filter, field);
        case FieldType.Text:
        case FieldType.MultiLineText:
        case FieldType.Note:
            return TextFieldFilter.parse(filter, field);
        case FieldType.SingleSelect:
            return SingleSelectFieldFilter.parse(filter, field);
        case FieldType.MultiSelect:
            return MultiSelectFieldFilter.parse(filter, field);
        case FieldType.Assignee:
            return AssigneeFieldFilter.parse(filter, field);
        case FieldType.SingleUser:
            return SingleUserFieldFilter.parse(filter, field);
        case FieldType.MultiUser:
            return MultiUserFieldFilter.parse(filter, field);
        case FieldType.Estimate:
            return EstimateFieldFilter.parse(filter, field);
        default:
            return unreachable(field);
    }
};
export const FieldFilter = {
    isValid,
    toString,
    parse
};
export { useFilterEffect } from './util';
